import { useEffect, useState } from 'react';
import logo from '~/assets/images/logo.png';
import {
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button/Button.model';
import { CloseButton } from '~/components/ui/CloseButton';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { AnticheatTab } from '../../components/AnticheatTab';
import { HeadMenu } from '../../components/HeadMenu';
import { HeadMenuItems } from '../../components/HeadMenu/HeadMenu.model';
import { RequestsTab } from '../../components/RequestsTab';
import {
	StyledContainer,
	StyledHead,
	StyledHeadLeftContainer,
	StyledHeadMenuContainer,
	StyledHeadRightContainer,
} from './AdminPanel.styled';

let lastActiveTab = HeadMenuItems.REQUESTS;

const AdminPanel = () => {
	const playerName = useObservable(rage.player.getNickname());
	const [activeTab, setActiveTab] = useState<HeadMenuItems>(
		() => lastActiveTab,
	);

	useEffect(() => {
		rage.admin.fetchRequests();
	}, []);

	const selectTab = (tab: HeadMenuItems) => {
		lastActiveTab = tab;
		setActiveTab(tab);
	};

	return (
		<StyledContainer>
			<StyledHead>
				<StyledHeadLeftContainer>
					<img src={logo} />
					<Text>Админ панель</Text>
				</StyledHeadLeftContainer>
				<StyledHeadRightContainer>
					<Text>
						Хорошей работы, <span>{playerName}</span>
					</Text>
					<CloseButton
						height={ButtonHeight.Height30}
						iconSize={14}
						color={ButtonColors.Default}
						onClick={() => {
							rage.admin.closePanel();
						}}
					/>
				</StyledHeadRightContainer>
			</StyledHead>
			<StyledHeadMenuContainer>
				<HeadMenu active={activeTab} onSelect={selectTab} />
			</StyledHeadMenuContainer>
			{activeTab === HeadMenuItems.ANTICHEAT ? (
				<AnticheatTab />
			) : (
				<RequestsTab />
			)}
		</StyledContainer>
	);
};

export { AdminPanel };
